export const COLORS = {
  PRIMARY: "#1976D2",
  SECONDARY: "#1565c0",
  BACKGROUND: "#fffcf2",
  BACKGROUND_BRIGHTER: "#fcfcfa",
  BACKGROUND_NORMAL: "#ccc5b9",
  BACKGROUND_DARK: "#403D39",
  BACKGROUND_DARKER: "#252422",
  ACCENT: "#403D39",
  TEXT_BRIGHT: "#fffcf2",
  TEXT_NORMAL: "#ccc5b9",
  TEXT_DARK: "#403D39",
  TEXT_DARKER: "#252422",
  DELETE: "#e35d5d",
  DELETE_HOVER: "#d34545",
  ADD: "#4caf50",
  ADD_HOVER: "#388e3c",
  TABLE_BORDER: "#e5e5e5",
  HOVER_BACKGROUND: "#F3F3F3",
  ACTIVE_BACKGROUND: "#D6F0FA",
  BORDER_BRIGHT: '#E5E5EC',
  BORDER_DASH: '#CCCCCC'
};

export const FONT_PROPS = {
  PRIMARY: "Pretendard", // 기본 폰트 Pretendard
  REGULAR: 400, // 폰트 굵기 regular
  MEDIUM: 500, // 폰트 굵기 medium
  SEMIBOLD: 600, // 폰트 굵기 semibold
  BOLD: 700, // 폰트 굵기 bold
  LINEHEIGHT: '140%', // 줄간격 140%
  //LETTERSPACING: '-2.5%', // 글자 간격 -2.5%
  MENU: '#03485E', // 메뉴 색상 #03485E
  DARK: '#111111', // 텍스트 색상 #111111
  GRAY: '#767676', // 텍스트 색상 #767676
  MEDIUMDARKGRAY: '#585858', // 텍스트 색상 #585858
  DARKGRAY: '#505050', // 텍스트 색상 #505050
  WHITE: '#ffffff', // 텍스트 색상 #ffffff
  ACTIVE_COLOR: '#0FA7D8', // 텍스트 색상 #03485E
};